import * as React from 'react';

import {
  PlanType,
  SubscriptionStatus,
} from '@showbie-socrative/socrative-utils';
import { HELP_ARTICLE_LINKS } from '@showbie-socrative/socrative-utils/lib/consts/constants';
import { translate } from '~l10n/client';
import { useAtomValue } from 'jotai';

import { AlertMessage } from '~shared/components/AlertMessage';
import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { planNameMap } from '~teacher/components/Account/TeamSubcription/util';
import { useTeams } from '~teacher/hook/team';

/**
 * These are the current plan types on offer
 */
export const currentPlans = [
  PlanType.Free,
  PlanType.Pro,
  PlanType.Essentials,
  PlanType.Organization,
  PlanType.Complete,
];

export function LegacyPlanBanner() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  const currentSubscriptionQuery = useTeams({
    select: (teams) => {
      const team = teams.find((team) => team.id === selectedTeamId);
      return team?.subscription;
    },
  });

  if (!currentSubscriptionQuery.data) {
    return null;
  }

  const { plan, status } = currentSubscriptionQuery.data;

  return <LegacyPlanBannerData plan={plan} status={status} />;
}

interface LegacyPlanBannerDataProps {
  plan: PlanType;
  status: SubscriptionStatus;
}

function LegacyPlanBannerData({ plan, status }: LegacyPlanBannerDataProps) {
  if (status === SubscriptionStatus.Expired) {
    return null;
  }

  if (currentPlans.includes(plan)) {
    return null;
  }

  return (
    <AlertMessage showIcon align="center" tone="info">
      <span
        dangerouslySetInnerHTML={{
          __html:
            translate(
              `The <strong>{0}</strong> plan you are on has been discontinued.`
            ).format(planNameMap?.[plan] ?? 'Pro') + ' ',
        }}
      />
      <a
        className="alert-message__link"
        href={HELP_ARTICLE_LINKS.CHOOSING_RIGHT_PLAN}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translate('Learn More')}
      </a>
    </AlertMessage>
  );
}
